"use client";
import React from 'react';
import { UniversalLocationInput } from './UniversalLocationInput';

export interface AddressData {
  streetAddress: string;
  addressLine2?: string;
  city: string;
  state: string;
  zipCode: string;
}

export interface GoogleAddressAutoCompleteProps {
  values: AddressData;
  onChange: (addressData: Partial<AddressData>) => void;
  errors?: {
    streetAddress?: string;
    addressLine2?: string;
    city?: string;
    state?: string;
    zipCode?: string;
  };
  fieldMapping?: {
    streetAddress?: string;
    addressLine2?: string;
    city?: string;
    state?: string;
    zipCode?: string;
  };
  title?: string;
  icon?: string;
  showGooglePlaces?: boolean;
  className?: string;
  showHeader?: boolean; // Control whether to show the internal header
  onBlur?: (e: React.FocusEvent<HTMLInputElement | HTMLSelectElement>) => void;
}

const GoogleAddressAutoComplete: React.FC<GoogleAddressAutoCompleteProps> = ({
  values,
  onChange,
  errors = {},
  className = "",
  showHeader = true,
  onBlur
}) => {
  const handleLocationChange = (locationData: any) => {
    onChange({
      streetAddress: locationData.streetAddress || '',
      addressLine2: locationData.addressLine2 || '',
      city: locationData.city || '',
      state: locationData.state || '',
      zipCode: locationData.zipCode || ''
    });
  };

  return (
    <UniversalLocationInput
      className={className}
      onLocationChange={handleLocationChange}
      initialValues={values}
      errors={errors}
      showHeader={showHeader}
      onBlur={onBlur}
    />
  );
};

export default GoogleAddressAutoComplete; 